var _ = require('lodash');

class StarRating {
    constructor(inputEl, starBlockEl, mobile) {
        this.hasClicked = false;
        this.inputEl = $(inputEl);
        this.resetRating();
        if (!mobile) {
            $(starBlockEl).on('mouseover', 'img', (e) => {
                var blockHolder =  this.inputEl.parent();
                _.map(_.range(1, 6), (star) => {
                    blockHolder.find('img[star='+star+']').attr('src', '/assets/img/front/icons/star-bor-blue1.svg');
                });
                var rating = parseInt($(e.target).attr('star'), 10);
                var elBlockHolder = $(e.target).parent();

                _.map(_.range(1, rating + 1), (star) => {
                    elBlockHolder.find('img[star='+star+']').attr('src', '/assets/img/front/icons/star-blue3.svg');
                });

                _.map(_.range(1,6), (star) => {
                    if (star == rating) {
                        elBlockHolder.find('.explanation_' + star).show();
                    } else {
                        elBlockHolder.find('.explanation_' + star).hide();
                    }
                });

            });

            $(starBlockEl).on('mouseout', 'img', (e) => {
                if (this.hasClicked) {
                    this.resetRating();
                    return;
                } else {
                    var blockHolder = $(e.target).parent();
                    _.map(_.range(1, 6), (star) => {
                        blockHolder.find('img[star='+star+']').attr('src', '/assets/img/front/icons/star-bor-blue1.svg');
                    });
                }
                this.resetRating();
            });
        }
        if (mobile) {
            $(starBlockEl).on('touchstart click', 'img', (e) => {
                e.stopPropagation(); e.preventDefault();
                this.hasClicked = true;
                var rating = parseInt($(e.target).attr('star'), 10);
                var blockHolder = $(e.target).parent();
                this.inputEl.val(rating * 2);
                this.resetRating();
            });
        } else {
            $(starBlockEl).on('click', 'img', (e) => {
                e.stopPropagation(); e.preventDefault();
                this.hasClicked = true;
                var rating = parseInt($(e.target).attr('star'), 10);
                var blockHolder = $(e.target).parent();
                this.inputEl.val(rating * 2);
                this.resetRating();
            });
        }
    }
    
    resetRating() {
        var currentRating = parseInt(this.inputEl.val()/2);
        var blockHolder =  this.inputEl.parent();
        _.map(_.range(1, currentRating + 1), (star) => {
            blockHolder.find('img[star='+star+']').attr('src', '/assets/img/front/icons/star-blue3.svg');
        });
        _.map(_.range(currentRating+1, 6), (star) => {
            blockHolder.find('img[star='+star+']').attr('src', '/assets/img/front/icons/star-bor-blue1.svg');
        });
        
        _.map(_.range(1,6), (star) => {
            if (star == currentRating) {
                blockHolder.find('.explanation_' + star).show();
            } else {
                blockHolder.find('.explanation_' + star).hide();
            }
        });
    }
}

module.exports = StarRating;
